module.exports = __webpack_public_path__ + "img/jpg-huadong@2x.038223e6.png";